module.exports = __webpack_public_path__ + "media/images/emblems/Mauensee_LU-380dbbc5ac30a4eebc8ef4111895fb74.png";